import React from 'react';
import PropTypes from 'prop-types';

import { VpInput } from '../../inputs';

export const VpMediaFileSizeInput = ({ value = '' }) => {
  return <VpInput disabled name="fileSize" value={value} label="File Size" />;
};

VpMediaFileSizeInput.propTypes = {
  value: PropTypes.string
};

export default VpMediaFileSizeInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/media-details/VpMediaFileSizeInput.jsx